import moment from 'moment';
import { v4 as uuid4 } from 'uuid';
import { releases } from '../../test.data';
import { ReleaseItem } from '../../types/release.type';
import { convertDateToX, occursInThis } from '../../utils/common.util';
import EmptyCard from '../cards/empty.card';
import ReleaseCard from '../cards/v2/release.card';
import Container from './container';

type ReleasesQuery = 'ALL' | 'THIS_WEEK' | 'THIS_MONTH' | 'COMING_SOON';

type Props = {
  trigger: Function;
  query: ReleasesQuery[];
  params: { genre: string };
};

export default function Releases(props: Props) {
  const { trigger, query } = props;

  const data: ReleaseItem[] = [];

  // temporary data querying from local data store
  if (query && query.length > 0) {
    for (const q of query) {
      data.push(...GET[q](props.params.genre));
    }
  } else {
    return (
      <div className="py-2 mobile:px-2 tablet-lg:px-[40px]">
        <EmptyCard variant="genre" />
      </div>
    );
  }

  const sortedData = data.sort(
    (a: ReleaseItem, b: ReleaseItem) =>
      convertDateToX(a.date, 'll') - convertDateToX(b.date, 'll')
  );

  return (
    <section className="my-2 px-2 tablet-lg:px-[40px]">
      <Container extensions="grid mobile:grid-cols-1 tablet-lg:grid-cols-2 gap-5 mobile:px-2 tablet-lg:px-0">
        {sortedData.map((release: ReleaseItem) => (
          <ReleaseCard key={uuid4()} onClick={trigger} data={release} />
        ))}
      </Container>
    </section>
  );
}

type ReleaseQueryMap = { [key in ReleasesQuery]: Function };

const GET: ReleaseQueryMap = {
  ALL: (genre: string): ReleaseItem[] => {
    return releases.filter(
      (release) => release.genre.toLowerCase() === genre.toLowerCase()
    );
  },

  COMING_SOON: (genre: string): ReleaseItem[] => {
    return releases.filter(
      (release) =>
        convertDateToX(release.date, 'll') >
          parseInt(moment().endOf('month').format('x')) &&
        release.genre.toLowerCase() === genre.toLowerCase()
    );
  },
  THIS_MONTH: (genre: string): ReleaseItem[] => {
    return releases.filter(
      (release) =>
        occursInThis('month', release.date) &&
        release.genre.toLowerCase() === genre.toLowerCase()
    );
  },
  THIS_WEEK: (genre: string): ReleaseItem[] => {
    return releases.filter(
      (release) =>
        occursInThis('week', release.date) &&
        release.genre.toLowerCase() === genre.toLowerCase()
    );
  },
};
